// 9fbef606107a605d69c0edbcd8029e5d 
module.exports = {
  CLIENT: 30000, // 30s
  SERVER: 30000, // 30s
};
